// @core/api/endpoints/platform/get_platform_product.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PlatformProductResponse,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Get platform product configuration
 * Retrieves the configuration for a specific product on the platform, including branding, available plans, and feature flags.
 */
export async function GetPlatformProduct(
  platform_id: string,
  product_id: string,
  options?: RequestOptions
): Promise<PlatformProductResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/:platform_id/products/:product_id`;
  requestPath = requestPath.replace(':platform_id', encodeURIComponent(platform_id));
  requestPath = requestPath.replace(':product_id', encodeURIComponent(product_id));
  const requestOptions = options;
  return client.get<PlatformProductResponse>(requestPath, { ...requestOptions });
}
